import jsUtils from '@pernod-ricard-global-cms/jsutils';
import Vue from 'vue';
import promoPopup from 'Templates/blocks/promoPopup/promoPopup.vue';
import globalTheme from 'Assets/js/components/globalTheme';
import Vuex from 'vuex';
import store from 'Assets/js/Vuex/Store/store';

export default function promopopup() {
  const popupEnabled = globalTheme.featureEnabled().promo_popups === true;

  if (!popupEnabled || store.getters.isB2B) {
    return;
  }

  const options = document.getElementById('promo-popup-id');
  try {
    if (options) {
      jsUtils.loadCss(options.dataset.assetkey, options).then(() => {
        options.style.display = 'block';
        const mountElement = options.children[0];
        if (mountElement && mountElement.__vue__) {
          return;
        }
        Vue.use(Vuex);
        new Vue({
          name: 'PromoOverlay',
          data: { ...mountElement.dataset, options },
          render: (h) => h(promoPopup),
          store
        }).$mount(mountElement);
      });
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('promopopup error', error);
  }
}
